//External
import React, { useEffect, useState } from "react";
import ReactHtmlParser from "react-html-parser";
import { useDispatch } from "react-redux";
import { Button } from "react-bootstrap";
import dynamic from "next/dynamic";
//Internal
import BrandVehicle from "../brandvehicle";
import Features from "../features";
const DynamicLazyGoogleReviews = dynamic(() => import("../googleReviews"));
import {
  clearVehicleList,
  setVehicleList,
  setVehicleMetaData,
  setVehicleTotalRecord,
} from "../../store/actions";
import {
  getBannerCategoryClassOfTitlePosition,
  get_cookie,
  hrefURL,
  IS_WEBP_LOADED,
  setBrandCategoryListAsUserBehaviour,
  setRecentSearch,
} from "utils";
// import logoWhite from "../../public/assets/images/brand-logo.svg";
import * as deviceObj from "react-device-detect";
import falconWhiteImage from "../../public/assets/images/Falcon_wordmark_white.svg";
import falconBlackImage from "../../public/assets/images/Falcon_wordmark_black.svg";

/*******************
  @Purpose :  used for Brand
  @Parameter : {
  brandBannerInfo,
  brandVehiclesData,
  currentLocationId,}
  categoryList,
  features,
  slug1,
  slug2,
  slug3,
  @Author : INIC
  *******************/
const Brand = ({
  brandBannerInfo,
  brandVehiclesData,
  categoryList,
  currentLocationId,
  features,
  slug1,
  slug2,
  slug3,
}) => {
  const img = brandBannerInfo?.bottom_content_img?.jpeg_w1920;
  const dispatch = useDispatch();
  const [show, toggleClass] = useState(false);
  const [webpImg, setWebpImg] = useState("");
  const [jpegImg, setJpegImg] = useState("");
  const [titlePart1, setTitlePart1] = useState();
  const [titlePart2, setTitlePart2] = useState();
  const [isMobile, setIsMobile] = useState(false);
  const [textLen, setTextLen] = useState(940);
  const [overlay, setOverlay] = useState("");
  // set youtube video url
  const [youtubeUrl, setYoutubeUrl] = useState("");
  const [isMobileScreen, setIsMobileScreen] = useState(false);
  const [isMobileApp, setIsMobileApp] = useState();
  // set brandVehicle data in state which get from server side props
  useEffect(() => {
    dispatch(clearVehicleList(""));
    dispatch(setVehicleList(brandVehiclesData?.data));
    dispatch(setVehicleMetaData(brandVehiclesData));
    dispatch(setVehicleTotalRecord(brandVehiclesData?.meta?.total));
  }, [slug3]);
  useEffect(() => {
    if (window.screen.width > 1024) {
      setWebpImg(brandBannerInfo?.image?.webp_w1920);
      setJpegImg(brandBannerInfo?.image?.jpeg_w1920);
      setIsMobile(false);
    } else {
      setWebpImg(brandBannerInfo?.mobile_image?.webp_w1200);
      setJpegImg(brandBannerInfo?.mobile_image?.jpeg_w1200);
      setIsMobile(true);
    }

    let str;
    let len;
    let firstPart = [];
    let secondPart = [];
    str = brandBannerInfo?.bottom_title?.split(" ");
    len = str?.length;

    if (brandBannerInfo?.bottom_title) {
      if (brandBannerInfo?.bottom_title?.toLowerCase().includes("miami")) {
        for (let i = 0; i < len - 1; i++) {
          firstPart.push(str[i]);
        }
        secondPart.push(str[len - 1]);
      } else {
        for (let i = 0; i < len - 2; i++) {
          firstPart.push(str[i]);
        }
        secondPart.push(str[len - 2]);
        secondPart.push(str[len - 1]);
      }

      setTitlePart1(firstPart.join(" "));
      setTitlePart2(secondPart.join(" "));
    }
    toggleClass(false);

    let url = "";
    const urlStr = brandBannerInfo?.bottom_mobile_video_url;
    const code = urlStr ? urlStr?.split("/")?.pop() : null;
    if (code) {
      url = "https://www.youtube.com/embed/" + code;
      setYoutubeUrl(url);
      if (window.screen.width > 767) {
        setTextLen(798);
      } else {
        // for mobile
        setTextLen(420);
      }
    } else {
      setYoutubeUrl("");
      if (window.screen.width > 767) {
        setTextLen(350);
      } else {
        // for mobile
        setTextLen(420);
      }
    }

    // recent search logic start here
    let slugUrl = hrefURL(brandBannerInfo?.brand_detail?.slug);
    let infoObj = {
      label: brandBannerInfo?.brand_detail?.title,
      image: brandBannerInfo?.brand_detail?.image?.jpeg_w180,
      slugUrl: slugUrl,
      type: "brand",
    };
    setRecentSearch(infoObj);
    // recent search logic end here

    // set brand list as user behaviour logic start here
    if (brandBannerInfo?.similar_brand_detail) {
      brandBannerInfo?.similar_brand_detail.reverse().forEach((row) => {
        setBrandCategoryListAsUserBehaviour(row.slug, "brand");
      });
    }

    setBrandCategoryListAsUserBehaviour(
      brandBannerInfo?.brand_detail?.slug,
      "brand"
    );
    // set brand list as user behaviour logic start here

    if (window.screen.width > 740) {
      setIsMobileScreen(false);
    } else {
      setIsMobileScreen(true);
    }

    setTimeout(() => {
      const video = document.getElementById("mobileVideoId");
      if (video) {
        video.setAttribute("playsinline", "");
        video.setAttribute("webkit-playsinline", "");
      }
    }, 200);
  }, [brandBannerInfo]);

  const overlaySetHandler = () => {
    if (deviceObj.isMobile || deviceObj.isIOS) {
      setOverlay(
        brandBannerInfo?.mobile_banner_overlay === 1 ? "banner-overlay" : ""
      );
    } else {
      setOverlay(
        brandBannerInfo?.desktop_banner_overlay === 1 ? "banner-overlay" : ""
      );
    }
  };

  useEffect(() => {
    overlaySetHandler();
    setIsMobileApp(get_cookie("is_mobile_app"));
  }, []);

  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <>
      {/* Category banner : Start */}
      {isMobileApp !== "yes" && (
        <section className={`category-banner ${overlay}`}>
          <picture className="banner-img">
            {IS_WEBP_LOADED && (
              <>
                <source
                  srcSet={webpImg}
                  alt={brandBannerInfo.title}
                  type="image/webp"
                  width={"100%"}
                  height={"618px"}
                  className="object-cover"
                />
                <source
                  srcSet={jpegImg}
                  alt={brandBannerInfo.title}
                  type="image/jpeg"
                  width={"100%"}
                  height={"618px"}
                  className="object-cover"
                />
              </>
            )}
            <img
              src={jpegImg}
              width={"100%"}
              height={"618px"}
              className="object-cover"
              alt={brandBannerInfo.title}
            />
          </picture>
          {/* Banner Content: Start */}
          <div
            className={getBannerCategoryClassOfTitlePosition(
              isMobile
                ? brandBannerInfo?.mobile_title_position
                : brandBannerInfo?.title_position
            )}
          >
            <div className="caption-wrap text-center">
              <div className="banner-logo-img">
                <img
                  // src={CDN_PATH + "/logo.png"}
                  src={
                    deviceObj.isMobile || deviceObj.isIOS
                      ? brandBannerInfo?.mobile_banner_logo === "white"
                        ? falconWhiteImage
                        : falconBlackImage
                      : brandBannerInfo?.desktop_banner_logo === "white"
                        ? falconWhiteImage
                        : falconBlackImage
                  }
                  height={56}
                  width={455}
                  objectFit="contain"
                  title="Falcon car rental"
                  alt="Falcon car rental"
                />
              </div>
            </div>
          </div>
          {/* Banner Content: End */}
        </section>
      )}
      {/* Category banner : End */}
      <BrandVehicle
        brandCategorydetail={brandBannerInfo.brand_detail}
        slug1={slug1}
        slug2={slug2}
        slug3={slug3}
        categoryList={categoryList}
        currentLocationId={currentLocationId}
        whichPage="brand"
        brandBannerInfo={brandBannerInfo}
      />
      {/* Section Divider  */}
      <div className="custom-container">
        <div className="section-divider wb-section"></div>
      </div>
      {isMobileApp !== "yes" && <Features features={features} />}
      {/* Section Divider  */}
      <div className="custom-container">
        <div className="section-divider wb-section"></div>
      </div>

      {brandBannerInfo?.bottom_content && (
        <section className="exotic-car py-75 border-thick-bottom pb-48 exotic-car-details mb-3 mb-sm-0">
          <div className="custom-container">
            <div
              className={`exotic-wrapper position-relative ${show ? "active" : ""
                }`}
            >
              {/* Mobile heading */}
              {brandBannerInfo?.mobile_video &&
                isMobileScreen &&
                brandBannerInfo?.mobile_video_thumbnail && (
                  <div className="mobile-space-20 mw-100 w-100 d-block d-sm-none">
                    <h2 className="mb-0 d-flex flex-wrap dec-main-title">
                      <span className="mr-2">The Experience</span>
                    </h2>
                  </div>
                )}
              {brandBannerInfo?.desktop_video &&
                !isMobileScreen &&
                brandBannerInfo?.desktop_video_thumbnail && (
                  <div className="exotic-video">
                    <div className="video-wrap">
                      <video
                        width="320"
                        height="240"
                        poster={brandBannerInfo?.desktop_video_thumbnail}
                        controls
                      >
                        <source
                          src={brandBannerInfo?.desktop_video}
                          type="video/mp4"
                        />
                      </video>
                    </div>
                  </div>
                )}
              {brandBannerInfo?.mobile_video &&
                isMobileScreen &&
                brandBannerInfo?.mobile_video_thumbnail && (
                  <div className="exotic-video">
                    <div className="video-wrap">
                      <video
                        id="mobileVideoId"
                        width="320"
                        height="240"
                        poster={brandBannerInfo?.mobile_video_thumbnail}
                        controls
                      >
                        <source
                          src={brandBannerInfo?.mobile_video}
                          type="video/mp4"
                        />
                      </video>
                    </div>
                  </div>
                )}
              <div className="exotic-heading mb-3 mw-100 w-100 d-block d-sm-none sm-exotic-heading">
                <h2
                  className="mb-0 mb-sm-4 mt-0 mt-sm-0 dec-title-brand"
                  id="description"
                >
                  <span className="mr-2">{titlePart1}</span>
                  <span>{titlePart2}</span>
                </h2>
              </div>

              {/* {youtubeUrl && (
                <div className="exotic-video w-auto mb-3 mb-sm-0">
                  <div className="video-wrap">
                    <iframe
                      className="short-video"
                      width="500"
                      height="532"
                      src={youtubeUrl}
                      title=""
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>
              )} */}
              {brandBannerInfo && brandBannerInfo?.bottom_content && (
                <div
                  className={`exotic-content overflow-hidden ${!isMobile && !brandBannerInfo?.desktop_video
                    ? "without-youtube-web"
                    : ""
                    }`}
                >
                  <div className="exotic-heading mt-3 mt-sm-0 mw-100 w-100 d-none d-sm-block">
                    <h2 className="mb-0 d-flex flex-wrap">
                      <span className="mr-2">{titlePart1}</span>
                      <span>{titlePart2}</span>
                    </h2>
                  </div>

                  {show ? (
                    ReactHtmlParser(brandBannerInfo?.bottom_content)
                  ) : (
                    <>
                      {ReactHtmlParser(
                        brandBannerInfo?.bottom_content?.substring(0, textLen) +
                        "<span>...</span>"
                      )}
                    </>
                  )}
                </div>
              )}
              {brandBannerInfo?.bottom_content &&
                brandBannerInfo?.bottom_content?.length > textLen && (
                  <>
                    <Button
                      variant="link"
                      className="read-more border-0 bg-transparent text-primary"
                      onClick={() => toggleClass(true)}
                    >
                      Read more{" "}
                      <span className="icon icon-chevron-right"></span>
                    </Button>
                    <Button
                      variant="link"
                      className="read-more read-less border-0 bg-transparent text-primary"
                      onClick={() => toggleClass(false)}
                    >
                      Read less{" "}
                      <span className="icon icon-chevron-right"></span>
                    </Button>
                  </>
                )}
            </div>
          </div>
        </section>
      )}
      {brandBannerInfo?.google_reviews?.length > 0 && isMobileApp !== "yes" && (
        <DynamicLazyGoogleReviews data={brandBannerInfo.google_reviews} />
      )}
      {/* Section Divider  */}
      {/* <div className="dth-mg">
        <div className="thick-devide mb-0 dth-mg-child"></div>
      </div> */}
      <div className="custom-container">
        <div className="section-divider wb-section"></div>
      </div>
    </>
  );
};

export default Brand;
